import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import ProductCard from "@/components/ProductCard";
import DealCard from "@/components/DealCard";
import { dispensaries as dApi, products as pApi, deals as dealsApi } from "@/lib/api";
import { MapPin, Star, Calendar, Phone } from "lucide-react";

export default function DispensaryDetail() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [products, setProducts] = useState([]);
  const [deals, setDeals] = useState([]);

  useEffect(() => {
    dApi.get(id).then(setD);
    pApi.list({ dispensary_id: id, sort: "value", limit: 30 }).then(setProducts);
    dealsApi.list().then((all) => setDeals(all.filter((x) => x.dispensary_id === id)));
  }, [id]);

  if (!d) return <div className="min-h-screen"><NavBar /><div className="text-center py-32">Loading...</div></div>;

  return (
    <div className="min-h-screen">
      <NavBar />
      <div className="relative h-72 sm:h-80 overflow-hidden border-b-2 border-[#0B0F0C]">
        <img src={d.cover_url || d.image_url} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F0C] via-[#0B0F0C]/60 to-transparent" />
        <div className="absolute bottom-8 left-0 right-0 max-w-7xl mx-auto px-5 lg:px-10">
          <span className={`sticker ${d.type === "medical" ? "sticker-cyan" : d.type === "hemp" ? "sticker-lemon" : "sticker-magenta"} !text-sm mb-3 inline-block`}>{d.type} · {d.state}</span>
          <h1 className="font-display text-5xl sm:text-7xl font-extrabold text-[#F5F0DC] tracking-tight leading-[0.92] mt-3">{d.name}</h1>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-10">
        <div className="grid lg:grid-cols-3 gap-6 mb-12">
          <div className="lg:col-span-2 text-[#0B0F0C]/75 leading-relaxed text-lg">{d.description}</div>
          <div className="card-x card-green bg-[#FAF6E8] p-6">
            <Row icon={<MapPin size={14} strokeWidth={2.4} />}>{d.address}</Row>
            <Row icon={<Star size={14} strokeWidth={2.4} />}>{d.rating?.toFixed(1)} rating</Row>
            <Row icon={<Calendar size={14} strokeWidth={2.4} />}>Daily 9am – 9pm</Row>
            <Row icon={<Phone size={14} strokeWidth={2.4} />}>(555) 010-{Math.floor(Math.random()*10000)}</Row>
            <Link to="/discover" className="btn-x btn-primary w-full mt-4 !text-sm">Get directions →</Link>
          </div>
        </div>
        {deals.length > 0 && (
          <section className="mb-12">
            <h2 className="font-display text-4xl sm:text-5xl font-extrabold mb-6 tracking-tight">Live <span className="text-rainbow">deals</span></h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">{deals.map((dl, i) => <DealCard key={dl.id} d={dl} idx={i} />)}</div>
          </section>
        )}
        <section>
          <h2 className="font-display text-4xl sm:text-5xl font-extrabold mb-6 tracking-tight">Catalog · {products.length}</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">{products.map((p) => <ProductCard key={p.id} p={p} />)}</div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

function Row({ icon, children }) {
  return (
    <div className="flex items-center gap-3 py-2 text-sm border-b border-dashed border-[#0B0F0C]/15 last:border-0 font-medium">
      <span className="text-[#FF1A8C]">{icon}</span>{children}
    </div>
  );
}
